var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deposit-order-amount c:col-center"},[_c('div',{staticClass:"deposit-order-amount-label"},[_vm._v("订金金额")]),_c('div',{staticClass:"deposit-order-amount-value"},[_vm._v("\n    ￥"+_vm._s(_vm._f("filterPrice")(_vm.order.amount))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }